var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasisschutz = function SvgBasisschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.127,
    height: 88.51
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisschutz_svg__a",
    x1: -2.164,
    x2: 9.306,
    y1: 31.863,
    y2: 33.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basisschutz_svg__a",
    id: "basisschutz_svg__b",
    x1: 60.837,
    x2: 67.853,
    y1: 42.814,
    y2: 43.841
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisschutz_svg__c",
    x1: 27.34,
    x2: 43.733,
    y1: 47.339,
    y2: 33.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basisschutz_svg__a",
    id: "basisschutz_svg__d",
    x1: 41.774,
    x2: 24.994,
    y1: 41.576,
    y2: 35.594
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basisschutz_svg__a",
    id: "basisschutz_svg__e",
    x1: 4.008,
    x2: 56.274,
    y1: 32.546,
    y2: 40.203
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5c1a3",
    d: "M35.563 88.51S53.2 73.588 59.513 66.118c9.008-10.651 13.495-42.895 10.87-56.575L35.563 0 .744 9.554c-2.625 13.67 1.861 45.913 10.87 56.564 6.313 7.47 23.95 22.392 23.95 22.392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf8364",
    d: "M34.963 80.023c-5.313-4.655-14.81-13.155-18.74-17.79C9.728 54.55 5.183 29.403 6.156 14.968l.044-.646 29.364-8.062 29.365 8.051.044.646c.973 14.433-3.572 39.58-10.068 47.263C50.71 67.18 40.4 76.324 36.162 80.024l-.6.524Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dba283",
    d: "M35.563 79.338c-6.058-5.308-14.9-13.277-18.644-17.693-6.37-7.534-10.8-32.6-9.855-46.617l28.5-7.824 28.499 7.814c.945 14.016-3.49 39.083-9.855 46.613-3.747 4.434-12.587 12.417-18.645 17.707"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisschutz_svg__a)",
    d: "M6.04 20.696a561 561 0 0 1-6.038-1.502 123.2 123.2 0 0 0 3.162 26.437q3.008-.875 5.873-1.501a120 120 0 0 1-2.996-23.434",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisschutz_svg__b)",
    d: "M64.416 30.404a108.8 108.8 0 0 1-4.908 22.776 56 56 0 0 1 4.936 4.035c2.997-7.566 5.084-17.54 6.057-26.859a77 77 0 0 1-6.085.048",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5d9",
    d: "m17.105 63.235-.15-.168c-.26-.288-.507-.57-.731-.833C9.727 54.55 5.182 29.402 6.155 14.967l.044-.646L34.286 6.61 6.018 13.662l-.468.128-.033.485-.043.646C4.492 29.477 9.11 54.88 15.702 62.675a68 68 0 0 0 6.065 5.32c-1.786-1.729-3.402-3.367-4.662-4.76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisschutz_svg__c)",
    d: "m36.087 27.727 3.041 6.163a.58.58 0 0 0 .44.319l6.8.988a.583.583 0 0 1 .324.995l-4.921 4.797a.58.58 0 0 0-.168.516l1.162 6.774a.583.583 0 0 1-.847.615l-6.083-3.198a.58.58 0 0 0-.543 0l-6.082 3.198a.583.583 0 0 1-.847-.615l1.162-6.774a.58.58 0 0 0-.168-.516l-4.921-4.797a.583.583 0 0 1 .323-.995l6.801-.988a.58.58 0 0 0 .44-.32l3.04-6.162a.583.583 0 0 1 1.047 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisschutz_svg__d)",
    d: "M35.564 27.402a.58.58 0 0 1 .523.325l3.041 6.163a.58.58 0 0 0 .44.319l6.8.988a.583.583 0 0 1 .324.995l-4.921 4.797a.58.58 0 0 0-.168.516l1.162 6.774a.582.582 0 0 1-.847.615l-6.083-3.198a.58.58 0 0 0-.543 0l-6.083 3.198a.582.582 0 0 1-.846-.615l1.162-6.774a.58.58 0 0 0-.168-.516l-4.921-4.797a.583.583 0 0 1 .323-.995l6.801-.988a.58.58 0 0 0 .44-.32l3.04-6.162a.58.58 0 0 1 .524-.325m0-.604a1.18 1.18 0 0 0-1.065.662l-3.042 6.162-6.785.977a1.188 1.188 0 0 0-.658 2.026l4.921 4.797-1.167 6.755a1.186 1.186 0 0 0 1.723 1.251l6.083-3.198 6.063 3.198a1.187 1.187 0 0 0 1.723-1.251l-1.162-6.774 4.916-4.778a1.188 1.188 0 0 0-.659-2.026l-6.8-.988-3.026-6.151a1.18 1.18 0 0 0-1.065-.662",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf8364",
    d: "m28.799 48.865 1.161-6.773a.58.58 0 0 0-.167-.516l-.283-.276a.6.6 0 0 1 .015.205l-1.162 6.774a.57.57 0 0 0 .443.65c.001-.022-.011-.04-.007-.064M39.564 34.476a.58.58 0 0 0 .439.32l6.8.988c.02.002.03.017.047.02a.57.57 0 0 0-.481-.607l-6.801-.988a.6.6 0 0 1-.17-.07ZM25.195 35.784l6.8-.988a.58.58 0 0 0 .44-.32l3.041-6.162a.575.575 0 0 1 .774-.257l-.163-.33a.583.583 0 0 0-1.046 0l-3.042 6.163a.58.58 0 0 1-.439.319l-6.8.988a.583.583 0 0 0-.324.995l.274.267a.58.58 0 0 1 .485-.675"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisschutz_svg__e)",
    d: "M9.732 43.057a75.8 75.8 0 0 1 15.427-1.666A58.2 58.2 0 0 1 59.051 51.73a110.3 110.3 0 0 0 4.335-20.452c-17.472-.668-41.674-5.874-56.397-9.416a122 122 0 0 0 2.743 21.195",
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  })));
};
export default SvgBasisschutz;